import { Box } from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';


function WalletDetails(props: any) {
    let { userWallet } = props;
  return (
    <div style={{marginRight:'1rem'}}>
        {
            userWallet && (
                <Box display={'flex'} alignItems={'center'} border={'1px solid green'} paddingX={'0.8rem'} paddingY={'0.5rem'} borderRadius={'1rem'}>
                    <AccountBalanceWalletIcon fontSize='medium' sx={{color: 'green'}}/>
                    <span style={{fontSize: '1em', fontWeight: 'bold'}}>
                        {userWallet?.amount ? userWallet.amount : 0}
                    </span>    
                </Box>

            )
        }
    </div>
  )
}

export default WalletDetails
